const STEP_TYPE_LABELS = {
    reading: "Reading",
    pf_quiz: "Exploration",
    practice_quiz: "Quiz",
    close: "Recap",
    handoff: "Where you got to",
};

export const stepLabel = (stepType) => STEP_TYPE_LABELS[stepType] ?? "Step";

export const destinationLabel = (viewType) => STEP_TYPE_LABELS[viewType] ?? "Lesson";

const STEP_STATUS_LABELS = {
    completed: "Completed",
    current: "Current",
    traced: "Visited",
    upcoming: "Upcoming",
};

export const stepStatusLabel = (state) => STEP_STATUS_LABELS[state] ?? "Upcoming";
